import results from '../data/results.json';

const NETLIFY_DOWNLOAD_SPEED = 0.005;

function ms(value) {
  return Math.ceil(value/1000000);
}

function timings(servers, key) {
  const value = ms(servers.reduce((sum, server) => sum + server[key], 0) / servers.length);
  const locations = servers.reduce((hash, server) => {
    hash[server.name] = ms(server[key]);
    return hash;
  }, {});
  const status = getStatus(key, value);

  return {locations, value, status};
}

function estimateNetlifyLoad(servers, complete_load) {
  const linear =servers[0] && ms(Math.max(servers[0].content_size / NETLIFY_DOWNLOAD_SPEED, 5000000));
  return {value: Math.min(linear, complete_load.value)};
}

function estimateFirstByte(servers, first_byte) {
  return {value: Math.min(7, first_byte.value)};
}

function getStatus(name, value) {
  const result = results[name];
  if (result == null) { return null; }

  if (result.criteria) {
    if (result.criteria[1] < value) {
      return "critical";
    }
    if (result.criteria[0] < value) {
      return "warning";
    }
    return "good";
  }

  return value == false ? "critical" : "warning";
}


// The results are duplicated. Each server returns an HTTP and HTTPS result.
// Make sure we pick just one of those sets - the HTTPS set takes priority.
function pickServerSet(results) {
  const sets = {
    http: [],
    https: []
  };
  for (const key in results) {
    const server = results[key];
    const set = key.match(/https$/) ? sets.https : sets.http;
    server.name = key.split("-")[1];
    set.push(server);
  }

  // Check if all HTTPS results worked
  if (sets.https.length && sets.https.filter((result) => result.raw_ip).length == sets.https.length) {
    return sets.https;
  }

  return sets.http;
}

function getBooleanResult(servers, name) {
  return {
    value: servers[0] && servers[0][name],
    status: getStatus(name, servers[0] && servers[0][name])
  };
}

export function processStats(results) {
  const servers = pickServerSet(results);
  const complete_load = timings(servers, 'complete_load');
  const first_byte = timings(servers, 'first_byte');
  const stats = {
    first_byte: first_byte,
    complete_load: complete_load,
    is_https: getBooleanResult(servers, 'is_https'),
    is_http_2: getBooleanResult(servers, 'is_http_2'),
    dns_resolve: timings(servers, 'dns_resolve'),
    tls_handshake: servers[0] && servers[0].is_https ? timings(servers, 'tls_handshake') : {value: null},
    certificate_algs: {value: servers[0] && servers[0].certificate_algs},
    same_ip: {value: servers.reduce((same, server) => (
      server.raw_ip == same ? server.raw_ip : null
    ), servers[0] && servers[0].raw_ip)},
    on_netlify: {value: servers[0] && servers[0].is_netlify_site},
    url: servers[0] && servers[0].url,
    netlify_first_byte: estimateFirstByte(servers, first_byte),
    netlify_estimate: estimateNetlifyLoad(servers, complete_load)
  };

  return stats;
}


export function performanceGain(test, netlify) {
  return Math.round(test.value / netlify.value * 100);
}



// WEBPACK FOOTER //
// ./src/utils/calculator.js